import { Component, Inject, Vue } from 'vue-property-decorator'
import { VERSION, ENVIRONMENT } from '@/constants'
import AccountService from '@/account/account.service'
import TranslationService from '@/locale/translation.service'
import MarketplaceLogo from '@/shared/marketplace-logo.vue'
import { Marketplace } from '@/shared/enums/marketplace'

@Component({
  components: {
    'marketplace-logo': MarketplaceLogo,
  },
  watch: {
    selectedMarketplace (newMarketplace): void {
      this.newSelectedMarketplace = newMarketplace
    },
  },
})
export default class JhiNavbar extends Vue {
  @Inject('translationService') private translationService: () => TranslationService;

  @Inject('accountService') private accountService: () => AccountService;
  public version = VERSION
  public environment = ENVIRONMENT
  public newSelectedMarketplace: Marketplace = this.$store.state.marketplaceStore.selected

  created (): void {
    this.translationService().refreshTranslation()
  }

  public openMarketplaceModal (): void {
    this.$root.$emit('mc-show-modal', 'changeMarketplace')
  }

  public closeMarketplaceModal (): void {
    this.$root.$emit('mc-hide-modal', 'changeMarketplace')
  }

  public selectMarketplace (): void {
    this.$store.commit('selectMarketplace', this.newSelectedMarketplace)
    this.$root.$emit('new-selected-marketplace', { marketplace: this.newSelectedMarketplace })
    this.closeMarketplaceModal()
  }

  public logout (): void {
    this.accountService().logout()
  }

  public get authenticated (): boolean {
    return this.$store.getters.authenticated
  }

  public hasAnyAuthority (authorities: any): boolean {
    return this.accountService().hasAnyAuthority(authorities)
  }

  public get swaggerEnabled (): boolean {
    return this.$store.getters.activeProfiles.indexOf('swagger') > -1
  }

  public get inProduction (): boolean {
    return this.environment === 'PROD'
  }

  public get selectedMarketplace (): string {
    return this.$store.state.marketplaceStore.selected || 'messaging'
  }

  public get userMarketplaces (): Marketplace[] {
    return this.$store.getters.account.marketplaces
  }

  public get userLogin (): string {
    return this.$store.getters.account.login
  }
}
